import axios, { AxiosResponse } from "axios";
import config from "../config";
import { Exception } from "sass";
import { P2_CHANGE_IMAGE } from "./urls";
import { Const } from "const";
import { CurUser,  Utils } from "helpers/utils";

export enum API_MESSAGE {
  INTERNAL_SERVER_ERROR_500 = "Internal Server Error",
  INVALID_CREDENTIALS_401 = "Invalid credentials",
  RESOURCE_NOT_FOUND_404 = "Sorry! the data you are looking for could not be found"

}

// default
axios.defaults.baseURL = config.API_URL;

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// intercepting to capture errors
axios.interceptors.response.use(
  function (response: any) {
    return response.data ? response.data : response;
  },
  function (error: any) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.status) {
      case 500:
        message = API_MESSAGE.INTERNAL_SERVER_ERROR_500;// "Internal Server Error";
        break;
      case 401:
        message = API_MESSAGE.INVALID_CREDENTIALS_401;// "Invalid credentials";
        break;
      case 404:
        message = API_MESSAGE.RESOURCE_NOT_FOUND_404;// "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error.message || error;
    }
    // return Promise.reject(message);
    return Promise.reject(error);
  }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: any) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */
  get = (url: string, params?: {}) => {
    return axios.get(url, params);
  };

  /**
   * post given data to url
   */
  create = (url: string, data?: {}) => {
    return axios.post(url, data);
  };

  /**
   * Updates data
   */
  update = (url: string, data?: {}) => {
    return axios.put(url, data);
  };

  /**
   * Delete
   */
  delete = (url: string, config?: {}) => {
    return axios.delete(url, { ...config });
  };

  /*
   file upload update method
  */
  updateWithFile = (url: string, data: any) => {
    const formData = new FormData();
    for (const k in data) {
      formData.append(k, data[k]);
    }
    // const config = {
    //   headers: {
    //     ...axios.defaults.headers,
    //     "content-type": "multipart/form-data",
    //   },
    // };
    // return axios.put(url, formData, config);
  };

  /*
   file upload post method
   */
  createWithFile = (url: string, data: any) => {
    const formData = new FormData();
    for (const k in data) {
      formData.append(k, data[k]);
    }
    // const config = {
    //   headers: {
    //     ...axios.defaults.headers,
    //     "content-type": "multipart/form-data",
    //   },
    // };
    return axios.post(url, formData);
  };

  // fnPost = (url: string, data?: {}) => {
  //   return axios.post(url, data);
  // };
  fnPost = async (url: string, data?: {}): Promise<any> => {
    try {
      //console.log('axios post', url, data);
      const response = await axios.post(url, data, {
        headers: {
          'Authorization': `Bearer ${Utils.JwtTokenGet()}` // 20250708          
        },
        withCredentials: true

      });
      //console.log(response);
      return response;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error; // Re-throw the error to handle it later
    }
  };

  fnPostBody = async (url: string, data: any): Promise<any> => {
    const jwtToken = Utils.JwtTokenGet();
    try {
      // console.log('API post form data ', url, data);

      const response = await axios.post(url, data, {
        // headers: {
        //   'Content-Type': 'multipart/form-data',
        // },
        headers: {
          //'Authorization': `Bearer ${Utils.JwtTokenGet()}` // 20250708          
          'Authorization': `Bearer ${jwtToken}` // 20250708          
        },
        withCredentials: true // Optional, if you need to send cookies
      });

      return response;
    } catch (error) {
      if ((error as any).status == 401) { // invalid credentical
        // const authUser = localStorage.getItem("authUser");
        const authUser = CurUser.GetAuthUserFromLocal();
        if (authUser) { // mean user previuosly login
          await CurUser.ClearFromLocal("fnPostBody: " + url, "Got 401 Unthorized" + (jwtToken ? "" : " and no JWT") + " and go /logoutex?401");
          // localStorage.removeItem("authUser");
          // Utils.JwtTokenSet(null);
          window.location.href = '/logoutex?401';
        }
      } else {
        if (axios.isAxiosError(error)) {
          if (error.response?.status === 400) {
            const payload = error.response.data;

            console.log(payload.message); // "Validation failed"

            if (payload.errors) {
              payload.errors?.forEach((e: any) => {
                console.error(`Field: ${e.field}`, e.errors);
              });
            }
          }
        }
      }
      Utils.HandleException(error, false);
      throw error;
    }
  };

  fnPostForm = async (url: string, data?: { [key: string]: any }): Promise<any> => {

    const formData = new FormData();

    if (data) {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const value = data[key];
          if (value) { // if value is null, then not include in body to able catch by asp.net web API null parameter

            if (value instanceof Blob) {
              formData.append(key, value);
            } else if (value instanceof Date) {
              formData.append(key, Utils.ToLocalDateString(value));
            } else if (Array.isArray(value)) {
              value.forEach((item, index) => {
                formData.append(`${key}[${index}]`, String(item));
              });
            } else {
              formData.append(key, String(value));
            }
          }
        }
      }
    }

    const jwtToken = Utils.JwtTokenGet();

    try {
      // console.log('API:' + url, data, 'Bearer:' + Utils.JwtTokenGet());
      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${jwtToken}` // 20250708
        },
        withCredentials: true // Optional, if you need to send cookies
      });
      // console.log('RSP:'+url, response);

      return response;
    } catch (error) {
      // if (url == '/me'){
      //   console.log(error);
      //   throw new Error('hello world');
      // }
      if ((error as any).status == 401) { // invalid credentical
        // const authUser = localStorage.getItem("authUser");
        // try {
        //   await Utils.LogDb("Logout from call " + url + " got 401 jwt = " + jwtToken, 1, "fnPostForm", Utils.GetDeviceId());
        // } catch (e401) {


        // }
        const authUser = CurUser.GetAuthUserFromLocal();
        if (authUser) { // mean user previuosly login
          await CurUser.ClearFromLocal("fnPostForm: " + url, "Got 401 Unthorized" + (jwtToken ? "" : " and no JWT") + " and go /logoutex?4011");
          // localStorage.removeItem("authUser");
          // Utils.JwtTokenSet(null);
          window.location.href = '/logoutex?4011';
        }
      }
      Utils.HandleException(error, false);
      // console.error(`Error in fnPostForm (${url}):`, error);
      throw error;
    }
  };


  fnGet = async (url: string, params?: {}): Promise<any> => {
    let log = {
      url: url,
      params: params,
      respond: null,
      err: '',
    };
    try {
      const response = await axios.get(url,
        {
          params,
          headers: {
            'Authorization': `Bearer ${Utils.JwtTokenGet()}` // 20250708            
          },
          withCredentials: true

        });
      // console.log('axios get', url, params);
      // console.log(response);
      log.respond = response as any;
      // console.log(log);
      return response;
    } catch (error: any) {
      log.err = ((error as Error).message);
      //console.log(log, error);//'Error get data:', error);
      throw error; // Re-throw the error to handle it later
    }
  };

  uploadFile = async (blobUrl: string, seq: number, fileName: string, msgId: string, system?: string | null, fileId?: string | null, returnErrMsg: boolean | null = true): Promise<string> => {
    try {
      if (system == null) system = Const.SYS_CHAT;
      if (fileId == null) fileId = Utils.GetUniqueId();
      const response = await fetch(blobUrl); // Fetch the Blob data
      if (!response.ok) {
        console.error("Failed to fetch Blob:", response.statusText);
        // return "[E01] ไฟล์หรือรูปที่ท่านแนบ อาจทิ้งไว้นานเกินไป ไม่สารถดึงข้อมูลเพื่อทำการส่งได้ ให้แนบไฟล์หรือรูปใหม่ ";
        throw new Error("[E01] ไฟล์หรือรูปที่ท่านแนบ อาจทิ้งไว้นานเกินไป ไม่สารถดึงข้อมูลเพื่อทำการส่งได้ ให้แนบไฟล์หรือรูปใหม่ ");
        // return "Error fetching Blob data";
      }
      const blob = await response.blob(); // Get the Blob object
      if (!blob || blob.size === 0) {
        console.error("Blob is empty or invalid");
        // return "[E02] ไฟล์หรือรูปที่ท่านแนบ อาจทิ้งไว้นานเกินไป ไม่สารถดึงข้อมูลเพื่อทำการส่งได้ ให้แนบไฟล์หรือรูปใหม่ ";
        throw new Error("[E02] ไฟล์หรือรูปที่ท่านแนบ อาจทิ้งไว้นานเกินไป ไม่สารถดึงข้อมูลเพื่อทำการส่งได้ ให้แนบไฟล์หรือรูปใหม่ ");
        // return "Invalid Blob data";
      }
      const maxSize = (Utils.ToNumber(process.env.REACT_APP_MAX_UPLOAD, null) ?? 999999999999);
      // console.log({size:blob.size, maxSize, conf:process.env.REACT_APP_MAX_UPLOAD});
      if (blob.size > maxSize) {
        const err = `ขนาดไฟล์ เกินกำหนด ที่ ${maxSize / 1024 / 1024}MB`;
        console.error(err);
        throw new Error(err);
      }

      const formData = new FormData();
      formData.append("file", blob, fileName); // You can specify a filename here
      formData.append("seq", seq.toString());
      formData.append("msgId", msgId);
      formData.append("system", system);
      formData.append("fileId", fileId);
      // console.log('upload fileId =  ' + fileId);

      const uploadResponse = await axios.post("/upload-file", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${Utils.JwtTokenGet()}` // 20250708          
        },
        withCredentials: true // Optional, if you need to send cookies
      });

      if (returnErrMsg) {
        return ((uploadResponse as any).error);
      } else {
        return (uploadResponse as any);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error; // Ensure that we propagate the error to handle it later
    }
  };

  p2ChangeImage = async (file: any): Promise<string> => {
    try {
      // console.log('p2ChangeImage-start');
      const formData = new FormData();
      formData.append("profilePicture", file);

      const uploadResponse = await axios.post(P2_CHANGE_IMAGE, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${Utils.JwtTokenGet()}` // 20250708
        },
        withCredentials: true // Optional, if you need to send cookies
      });

      // console.log('uploadResponse:', uploadResponse);

      return (uploadResponse as any);
      // return ((uploadResponse as any).url);

    } catch (error) {
      console.error("Error uploading file:", error);
      throw error; // Ensure that we propagate the error to handle it later
    }
  };


};

const getLoggedinUser = () => {
  // const user = localStorage.getItem("authUser");
  const user = CurUser.GetAuthUserFromLocal();
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
